import { defineStore } from 'pinia';

import type { ToastType } from '@/hooks/useToast';

interface ToastState {
  showToast: boolean;
  toastContent: string;
  toastType: ToastType;
}

export const useToastStore = defineStore('toast', {
  state: (): ToastState => ({
    showToast: false,
    toastContent: '',
    toastType: 'success'
  }),
  actions: {
    setToast(toastContent: ToastState['toastContent'], toastType: ToastState['toastType'] = 'success') {
      this.showToast = true;
      this.toastContent = toastContent;
      this.toastType = toastType;
    }
  }
});
